/**
 * Created by Andrey Popov on 06.08.26
 */

cleverapps.Tool.gameAnnounce = ToolFolder.create(() => ({
    showWindow: function () {
        cleverapps.focusManager.closeAllWindows();
        cleverapps.focusManager.display({
            focus: "GameAnnounceWindowTool",
            action: function (f) {
                new GameAnnounceWindow();
                cleverapps.focusManager.onceNoWindowsListener = f;
            }
        });
    },
    allowShow: function () {
        const data = GameAnnounce.load();
        delete data.shownAtSession;
        delete data.connected;
        GameAnnounce.save(data);
    },
    resetEvents: function () {
        const data = GameAnnounce.load();
        delete data.loggedAvailable;
        delete data.loggedFirstLaunch;
        GameAnnounce.save(data);
    },
    reset: function () {
        GameAnnounce.save({});
    },
    gotoGame: function () {
        GameAnnounce.switchGame();
    },
    logState: function () {
        console.log(JSON.stringify({
            link: GameAnnounce.getLink(),
            payload: GameAnnounce.getPayload(),
            isAvailable: GameAnnounce.isAvailable(),
            canShow: GameAnnounce.canShow(),
            data: GameAnnounce.load()
        }, undefined, 4));
    }
}));
